import {hasLocalStorageFlag} from './localStorageFlags';

export const IOS_APP_REVIEW_CAPABILITY_LOCAL_STORAGE_KEY = 'ios_app_review_capability';

export const openExternally = (url: string) => {
  // @ts-ignore
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.openLink) {
    // @ts-ignore
    window.webkit.messageHandlers.openLink.postMessage(url);
  } else {
    alert('Native bridge not available.\nWill try fallback.');
    window.open(url, '_blank');
  }
}

export const logoutTrigger = () => {
  // @ts-ignore
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.logout) {
    // @ts-ignore
    window.webkit.messageHandlers.logout.postMessage(null);
  } else {
    alert('Native bridge not available.\nWill try fallback.');
    document.location.href = '/logout';
  }
}

export const paymentTrigger = (productId: string) => {
  // @ts-ignore
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.pay) {
    // @ts-ignore
    window.webkit.messageHandlers.pay.postMessage(productId);
  } else {
    alert('Native bridge not available.\nWill try fallback.' + productId);
  }
}
export const hasIosAppReviewCapability = (): boolean => {
  const webkitBridge = (window as any).webkit;

  return !!(webkitBridge && webkitBridge.messageHandlers && webkitBridge.messageHandlers.review) ||
    hasLocalStorageFlag(IOS_APP_REVIEW_CAPABILITY_LOCAL_STORAGE_KEY);
}
//review
export const requestIosAppReview = () => {
  const webkitBridge = (window as any).webkit;

  if (webkitBridge && webkitBridge.messageHandlers && webkitBridge.messageHandlers.review) {
    webkitBridge.messageHandlers.review.postMessage(null);
  } else if (hasLocalStorageFlag(IOS_APP_REVIEW_CAPABILITY_LOCAL_STORAGE_KEY)) {
    console.info('iOS app review requested via localStorage fallback');
  } else {
    alert('Native bridge not available.\nWill try fallback.');
  }
}
